import { useState } from 'preact/hooks'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import styles from './info-card-panel.module.css'

/**
 * The card of what the player inspected: on the right, or a bottom sheet on compact
 * screens. Click-through, so it never blocks the touch controls under it.
 */
export function InfoCardPanel() {
  const t = useT()
  const card = useView((view) => view.hud.card)
  // Presentation only: the last card stays on screen while it fades out.
  const [shown, setShown] = useState(card)
  if (card !== null && card !== shown) setShown(card)
  if (!shown) return null

  return (
    <aside class={styles.card} data-open={card !== null || undefined} aria-hidden={card === null}>
      <h2 class={styles.title}>{t(shown.title)}</h2>
      {shown.lines.map((line, i) => (
        <p key={i} class={styles.line}>
          {t(line)}
        </p>
      ))}
      {shown.credit && <p class={styles.credit}>{t(shown.credit)}</p>}
    </aside>
  )
}
